//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class NoticePatternService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[NoticePattern.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/notification/notice-pattern/create', params || { });
	};

	//GeneratorFlag:[NoticePattern.Delete]
	async delete(noticePatternId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:noticePatternId
		}
	
		return await _server.delete('/notification/notice-pattern/delete', {'params':params})
	};

	//GeneratorFlag:[NoticePattern.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/notification/notice-pattern/detail', {'params':params});
	};

	//GeneratorFlag:[NoticePattern.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/notification/notice-pattern/list', {'params':params});
	};

	//GeneratorFlag:[NoticePattern.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/notification/notice-pattern/update', params || { });
	};

//GeneratorFlag:[NewAction]
}